import React from 'react'

const Logo56 = () =>
  <a className='logo' target='_blank' rel='noopener noreferrer' href='https://56.digital'>
    <svg className='curp' version='1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 68.7'><path d='M0 68.7c1.3-.5 30.3-8.4 30.4-28.7-.2-6.7-2.3-9.4-8.1-9.4-5.6 0-11.1 3.3-14.8 7.4l-3.2-.6 5.9-31.9h22.2c6.8 0 10.5-.9 15-5.6h1.9l-6.5 17.6h-30L10 32.1c3.4-3.4 9.1-6.1 15-6.1 10 0 18.6 2.9 18.6 14.9C43.6 64.6 1 68.6 0 68.7zM91.4 3.7c-1.3.5-27.4 9.4-27.5 39.9C65 40 70 26.9 82.2 26.9c11.3 0 17.6 8.8 17.6 18.6 0 15.3-11.3 23.2-24.1 23.2-17.5 0-25.1-12.2-25.1-26.9 0-34.8 39.9-38 40.8-38.1zM63.9 44.2C64 55 69 64.1 77.6 64.1c5.9 0 11.1-3.9 11.1-13.9 0-7.4-4.9-12.1-12.1-12.1-7.7 0-11.8 4.7-12.7 6.1z' /></svg>
  </a>

export default Logo56
